var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('calculation-container',[_c('calculation-steps'),_vm._v(" "),_c('h2',{staticClass:"calculator__header"},[_vm._v("Vyberte si z nabízených řešení")]),_vm._v(" "),(_vm.projects.length)?_c('calculation-construction-list'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f2b4ebc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/calculation/calculator/construction/ConstructionSelectContainer.vue
// module id = null
// module chunks = 